import { render, staticRenderFns } from "./PainelCompraDiretaVisualizacao.vue?vue&type=template&id=bf2978fe"
import script from "./PainelCompraDiretaVisualizacao.vue?vue&type=script&lang=js"
export * from "./PainelCompraDiretaVisualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports